import React from "react";
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import Footer from "./components/Footer";
import AtBiyanis from './pages/AtBiyanis';
import TeachersTeam from './pages/TeachersTeam';
import BranchAndCourses from './pages/BranchAndCourses';
import Dream90 from './pages/Dream90';
import Locations from './pages/Locations';
import ApplyJob from './pages/ApplyJob';
import LearningResources from './pages/LearningResources';
import WorkingEnvironment from './pages/WorkingEnvironment';
import PrivacyPolicy from './pages/PrivacyPolicy';
import ScrollToTop from './components/ScrollToTop';

function App() {
  return (
    <Router>
      <ScrollToTop />
      <div className="app-container">
        <Navbar />
        <main className="main-content">
        <Routes>
            <Route path="/" element={<Hero />} />
          <Route path="/at-biyanis" element={<AtBiyanis />} />
          <Route path="/teachers-team" element={<TeachersTeam />} />
          <Route path="/dream90" element={<Dream90 />} />
          <Route path="/branch-and-courses" element={<BranchAndCourses />} />
            <Route path="/locations" element={<Locations />} />
            <Route path="/apply-job" element={<ApplyJob />} />
            <Route path="/work-environment" element={<WorkingEnvironment />} />
            <Route path="/learning-resources" element={<LearningResources />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
